<template>
    <div class="icon-process-wrapper">
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-calendar"></i>
                </div>
                <h5 class="icon-process-single__title">Pianifica gli interventi</h5>
                <div class="icon-process-single__text">
                    Puoi calendarizzare le attività sia programmate che spot assegnandole direttamente ad un tecnico.
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-users"></i>
                </div>
                <h5 class="icon-process-single__title">Genera rapportini digitali</h5>
                <div class="icon-process-single__text">
                    Ad attività terminata, il tecnico potrà generare un rapportino di intervento con firma del cliente.
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-check"></i>
                </div>
                <h5 class="icon-process-single__title">Monitora le attività</h5>
                <div class="icon-process-single__text">
                    Il personale del back-office avrà sempre la situazione sotto controllo, per una migliore gestione del cliente.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Gradation',
    };
</script>
